import { Panel } from "@poseidon/ui/components";
import { Grid } from "@mui/material";
import { Field } from "formik";
import TextField from "@mui/material/TextField";
import { getUserLabel } from "../Users/util";
import { formatCurrency } from "@poseidon/utils";
import { getDate } from "@poseidon/firebase/timestamp";

export const DealerApplicationSummary = ({
  application: { applicant, applicationNumber, costOfVessel, completionDate },
}) => (
  <Panel title="Application Summary">
    <Grid container spacing={2} mt={0}>
      <Grid item xs={12} sm={6}>
        <Field
          component={TextField}
          label="Application Number"
          margin="none"
          sx={{ width: 1 }}
          value={applicationNumber ?? "Unknown"}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          component={TextField}
          label="Sailor"
          margin="none"
          sx={{ width: 1 }}
          value={getUserLabel(applicant?.sailor)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          component={TextField}
          label="Cost of Vessel"
          margin="none"
          sx={{ width: 1 }}
          value={formatCurrency(costOfVessel)}
          helperText="If this is incorrect - please contact salt"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          component={TextField}
          label="Completion Date"
          margin="none"
          sx={{ width: 1 }}
          value={getDate(completionDate)?.toLocaleDateString() ?? "TBC"}
        />
      </Grid>
    </Grid>
  </Panel>
);
